<template>
  <div id="insurance-info">

    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/insurances'">保险商城</router-link>
      <div class="bread-arrow">&gt;</div>
      <div class="bread-item bread-ellipsis">{{insuranceData.product_name}}</div>
    </div>

    <div class="order-box">

      <!-- 右侧边栏 -->
      <div class="info-box" :style="{transform: `translateY(${rightBoxTranslateY}px)`, top: `${rightTop}px`}">
        <right-insurance-info :insurance-data="insuranceData" :insurance-id="insuranceId"></right-insurance-info>
      </div>

      <div class="insurance-order">
        <left-insurance-form v-model="insuranceData" :insurance-id="insuranceId"></left-insurance-form>
      </div>

    </div>
  </div>
</template>

<script>
import utils from '@/libs/utils';
import insuranceApi from '@/api/insurance-api';
import insuranceService from '@/services/insurance-service';
import rightInsuranceInfo from './components/right-insurance-info.vue';
import leftInsuranceForm from './components/left-insurance-form/left-insurance-form.vue';
import insuranceInfoService from '@/pages/insurance/services/insurance-info-service';


export default {
  name: 'insuranceInfo',
  components: {
    rightInsuranceInfo,
    leftInsuranceForm,
  },
  data() {
    return {
      insuranceId: parseInt(this.$route.query.insuranceId, 10), // 保险id，从url获取
      insuranceData: { // 保险下单请求数据
        applicant: { sex: '' },
        insurants: [{
          cname: '',
          ename: '',
          card_type: '',
          card_code: '',
          sex: '',
          birthday: '',
        }],
        single_price: 0,
        original_price: 0,
        insurance_type_id: 1,
      },

      rightBoxTranslateY: 0,
      rightTop: 128, // right-box Top值
    };
  },
  computed: {

  },
  created() {
    if (!window.XLSX) {
      utils.jsLoad('https://o.666visa.cn/static/xlsx.core.min.js');
    }
    const loadingIns = this.$loading();
    insuranceApi.insuranceOrderQuery({ insurance_id: this.insuranceId }).then((data) => {
      this.insuranceData = utils.extend({}, this.insuranceData, data);
      this.insuranceData.insure_date_range = insuranceService.flatProtectOptions(data.insure_date_range);
      // 转换日期字符串为日期对象-----判断是否编辑，从支付页点编辑进来或者直接当前链接进来
      const isEdit = this.insuranceData.insurants.some(it => it.insurance_num); // 有insurance_num说明是编辑
      if (isEdit) {
        this.insuranceData.start_date = new Date(this.insuranceData.start_date);

        this.insuranceData.applicant.birthday = this.insuranceData.applicant.birthday ? new Date(this.insuranceData.applicant.birthday) : undefined;
        if (this.insuranceData.applicant.job) {
          const applicantJob = [];
          this.insuranceData.applicant.job.split('-').forEach((jobItem) => {
            const jobObj = data.job_set.jobs.find(item => item.name === jobItem);
            applicantJob.push(jobObj.id);
          });
          this.insuranceData.applicant.job = applicantJob;
        }
        this.insuranceData.insurants.forEach((ins) => {
          ins.birthday = new Date(ins.birthday);
          if (ins.job) {
            const applicantJob = [];
            ins.job.split('-').forEach((jobItem) => {
              const jobObj = data.job_set.jobs.find(item => item.name === jobItem);
              applicantJob.push(jobObj.id);
            });
            ins.job = applicantJob;
          }
        });
      } else {
        this.initMiYaInsurance(data);
      }
      loadingIns.close();
      this.calculatePrice();
    }).catch((e) => {
      if (e) console.log(e);
      loadingIns.close();
    });
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  // 离开页面之前提示保存信息
  beforeRouteLeave(to, from, next) {
    if (to.name === 'insurancePay' && to.query.insuranceId) {
      next();
    } else if (to.name === 'login') {
      next();
    } else {
      utils.msgbox.confirm('离开页面，所有已填写信息都将丢失，确定要离开吗？', '要离开该网页吗？', {
        confirmButtonText: '离开',
        cancelButtonText: '继续填写',
        type: 'warning',
      }).then(() => {
        next();
      }).catch((e) => {
        if (e) console.log(e);
      });
    }
  },

  methods: {
    // 根据选项计算保险金额
    async calculatePrice() {
      try {
        const { single_price, original_price } = await insuranceInfoService.calculatePrice(this.insuranceData);
        this.insuranceData.single_price = single_price;
        this.insuranceData.original_price = original_price;
      } catch (e) {
        console.log('eeeee', e);
      }
    },
    handleScroll() {
      const insuranceTop = document.querySelector('.insurance-order').getBoundingClientRect().top;
      const insuranceHeight = document.querySelector('.insurance-order').getBoundingClientRect().height;
      // 左侧商品的底部距离屏幕的距离
      const insuranceLastTop = insuranceTop + insuranceHeight;

      // 处理右侧fixed滚动问题
      const rightBoxEl = document.querySelector('.info-box');
      if (rightBoxEl) {
        const rightBoxTop = rightBoxEl.offsetTop;
        const rightBoxHeight = rightBoxEl.offsetHeight;
        // 右侧小程序码的底部距离屏幕的距离，如果大于国家的高度，则国家需要往上偏移
        if (rightBoxTop + rightBoxHeight > insuranceLastTop) {
          this.rightBoxTranslateY = insuranceLastTop - (rightBoxTop + rightBoxHeight);
        } else {
          this.rightBoxTranslateY = 0;
        }

        if (insuranceTop > 84 && insuranceTop < 128) {
          this.rightTop = insuranceTop;
        } else {
          this.rightTop = 84;
        }
      }
    },
    // 美亚时候初始化特殊处理
    initMiYaInsurance(data) {
      // 初次下单赋值，// 判断是否为美亚，如果是还需要把【被保人本人投保】选项强制设置为开启
      if (data.is_aig_insurance) {
        this.insuranceData.is_self_insure = 1;
        this.insuranceData.insurants.forEach((ins) => {
          ins.relation_id = 1;// 强制本人
        });

      }
    },
  },

};
</script>

<style lang="less" scoped>
@import "../../../../assets/less/variable";

#insurance-info {
  width: 1120px;
  margin: 0 auto 70px;
  .order-box {
    position: relative;
    margin-bottom: 30px;
    .info-box {
      position: fixed;
      top: 128px;
      right: calc(~'(100% - 1120px) / 2');
      width: 304px;
      padding: 16px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);
    }

    .insurance-order {
      width: 800px;
      background-color: #fff;
      box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);
    }

  }

  /deep/ .order-block {
    .title{
      padding-left: 24px;
      display: flex;
      align-items: center;
      background:linear-gradient(270deg,rgba(255,255,255,1) 0%,rgba(242,247,255,1) 100%);
      height: 44px;
      color: #2F333D;
      font-size: 18px;
      font-weight: 600;
      &.personal {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 24px;
        .self-btn {
          font-size: 14px;
          color: #5F666E;
          line-height: 20px;
          font-weight: normal;
          display: flex;
          align-items: center;
          /deep/ .el-switch {
            transform: scale(0.7);
            margin-right: 2px;
          }
        }
      }
    }
    .content {
      padding: 20px 24px;
      display: flex;
      flex-wrap: wrap;
      margin-left: -15px;
      margin-right: -15px;
    }
  }

}
</style>

<style lang="less">
@import "../../../../assets/less/variable";

#insurance-info {

  .el-radio-group {
    .el-radio {
      margin-right: 15px;
    }
  }

  .el-form-item__label {
    &::before {
      display: none;
    }
  }

  .el-form-item__content {
    .el-form-item__error {
      padding-bottom: 4px;
      color: #FF6464;
    }

    .el-date-editor {
      height: 40px;
      width: 100%;
    }
    .el-input__inner {
      height: 40px;
      width: 100%;
      border-radius: 2px;
      color: #2F333D;
    }
    .el-select{
      height: 40px;
      width: 100%;
      .el-input{
        .el-input__icon{
          width: 24px;
          transform: translateY(-50%) rotateZ(180deg) scale(0.7);
          transform-origin: center center;
          right: 4px;
          color: #91999F;
          &.is-reverse{
            transform: translateY(-50%) scale(0.7);
          }
        }
        .el-input__inner{
          height: 40px;
          border-radius: 2px;
          padding-right: 24px;
        }
      }
    }
    .el-cascader{
      height: 40px;
      width: 100%;
      .el-cascader__label{
        line-height: 40px;
      }
      .el-input{
        .el-input__icon{
          width: 24px;
          transform: scale(0.7);
          transform-origin: center center;
          right: 4px;
          color: #91999F;
          font-size: 12px;
          &.is-reverse{
            transform: rotateZ(180deg) scale(0.7);
          }
        }
        .el-input__inner{
          height: 40px;
          border-radius: 2px;
          padding-right: 24px;
        }
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/insuranceInfo/InsuranceInfo.vue